<div
  [ngClass]="{
    aiBox:
      (($safeNavigationMigration(cargoPaymentInfo?.signatureRequired) | lowercase) === 'y' &&
        cargoPaymentInfo?.signatureRequirement !== 'NotRequired') ||
      (($safeNavigationMigration(cargoPaymentInfo?.signatureRequired) | lowercase) === 'y' &&
        cargoPaymentInfo?.signatureRequirement === 'NotRequired' &&
        buttonName !== 'Done' &&
        (paymentType === 'Customer Payment' || !currentLoadingState)),
    aiBoxTwo:
      (buttonName === 'Done' && paymentType === 'Manual Payment') ||
      (cargoPaymentInfo?.signatureRequirement !== 'NotRequired' &&
        (cargoPaymentInfo?.operationMode === 'Cash' || $safeNavigationMigration(cargoPaymentInfo?.operationMode) === undefined) &&
        currentLoadingState) ||
      (buttonName === 'Done' && cargoPaymentInfo?.signatureRequirement === 'NotRequired' && paymentType === 'Customer Payment') ||
      ($safeNavigationMigration(cargoPaymentInfo?.signatureRequired) | lowercase) === 'n' ||
      (($safeNavigationMigration(cargoPaymentInfo?.signatureRequired) | lowercase) === 'y' &&
        cargoPaymentInfo?.signatureRequirement === 'NotRequired' &&
        currentLoadingState)
  }"
>
  <span class="pTittle">Summary</span>
  <span class="sTitle c1">Payment advice #</span>
  <span class="sTitle c2">Air waybill # </span>
  <span class="sTitle c3">Airport code </span>
  <span class="sTitle c4">Form of payment </span>
  <span class="sTitle c5">Currency </span>
  <div class="line"></div>
  <span class="sTitle c6">Total payable amount </span>
  <span class="value c1">{{
    $safeNavigationMigration(cargoPaymentInfo?.paymentAdviceNumber) !== undefined && cargoPaymentInfo?.paymentAdviceNumber !== 'null'
      ? cargoPaymentInfo?.paymentAdviceNumber
      : 'N/A'
  }}</span>
  <span class="value c2">{{
    $safeNavigationMigration(cargoPaymentInfo?.awbNumber) !== undefined ? cargoPaymentInfo?.awbNumber : 'N/A'
  }}</span>
  <span class="value c3">{{
    $safeNavigationMigration(cargoPaymentInfo?.airportCode) !== undefined ? cargoPaymentInfo?.airportCode : 'N/A'
  }}</span>
  <span class="value c4">{{
    $safeNavigationMigration(cargoPaymentInfo?.operationMode) !== undefined ? cargoPaymentInfo?.operationMode : 'N/A'
  }}</span>
  <span class="value c5">{{
    $safeNavigationMigration(cargoPaymentInfo?.paymentAdviceCurrency) !== undefined && cargoPaymentInfo?.paymentAdviceCurrency !== 'null'
      ? cargoPaymentInfo?.paymentAdviceCurrency
      : 'N/A'
  }}</span>
  <span class="value c6">{{
    $safeNavigationMigration(cargoPaymentInfo?.paymentAdviceAmount) !== undefined
      ? '$' + ($safeNavigationMigration(cargoPaymentInfo?.paymentAdviceAmount) | number : '1.2-2')
      : 'N/A'
  }}</span>
</div>
